import {dataActions} from '../../actions'
import {dataConstants} from '../../constants'

// dataFetchProps maps slices of the Redux store to props in the connect HOC
// Use this in place of mapStateToProps on connected components
export function dataFetchProps(state) {
    return {
        loggedIn: state.authentication.loggedIn,
        checkingLoginStatus: state.authentication.checkingLoginStatus,
        token: state.authentication.token,
        eventLoading: state.eventdata.fetchingEvents,
        occurrenceLoading: state.occurrencedata.loadingOccurrence,
        eventlist: state.eventdata.eventlist,
        occurrence: state.occurrencedata.occurrence,
        error:
            state.eventdata.errors.length > 0 ||
            state.swipedata.errors.length > 0 ||
            state.occurrencedata.errors.length > 0,
    }
}

// Dispatch actions to store for data fetches.
// Use this in place of mapDispatchToProps on connected components
export const dataFetches = {
    eventFetchRequest: token => dataActions.eventFetchRequest(token),
    setOccurrence: payload => dataActions.occurSetRequest(payload),
}

// This function uses the fetchrequests parameter to call functions in dataFetches{} object
export function calldataFetches(props, fetchrequests) {
    const {token, eventFetchRequest} = props

    const iterator = fetchrequests.values()

    for (const value of iterator) {
        switch (value) {
            case dataConstants.EVENTS:
                eventFetchRequest(token)
                break
            default:
                break
        }
    }
}
